<template>
    <div class="x_t">
        <div v-if='text' class="con">{{text}}</div>
    </div>
</template>

<script>
export default {
    name: "",
    computed: {},
    props:{
        text:String
    },
    data() {
        return {

        };
    },
    created() {},
    mounted() {},
    destroyed() {},
    methods: {},
    components: {},
};
</script>
<style lang="less" scoped>
.x_t {
    text-align: center;
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    height: 75px;
    line-height: 75px;
    margin: 50px 0 105px 0;
    display: flex;
    background: url('../../../assets/dongxiang/head.png') no-repeat;
    background-size: 100% 100%;
    div{
        width:100%;
    }
    .con{
        background-image: -webkit-linear-gradient(left bottom,#BDFDFF,#3DE1FC);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
}
</style>










